import React from 'react';

import { PRODUCT_SUPPORT_EMAIL } from '../constants/constants';
import { useTranslation } from 'react-i18next';

const DeleteAccount_es = () => {
  const { t } = useTranslation();

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        <div style={{ width: '90%' }}>
          <br />
          <h4>ELIMINAR CUENTA</h4>
          <p>
            <strong>
              Si necesita eliminar su cuenta, siga estos pasos:
            </strong>
          </p>
          <ol>
            <li>Abra la aplicación móvil de Begin Bright e inicie sesión en su cuenta</li>
            <li>Haga clic en el icono de la persona en la esquina inferior derecha de la aplicación.</li>
            <li>Haga clic en el botón rojo "Eliminar cuenta".</li>
          </ol>
          <p>
            <strong>Atención:</strong> Si decide eliminar su cuenta, se borrarán todos los datos asociados, incluidos sus certificados de finalización. Este proceso es irreversible.
          </p>
          <p>
            <strong>¿Necesita ayuda?</strong> Si tiene algún problema al intentar eliminar su cuenta, no dude en contactarnos en <a href={"mailto:"+PRODUCT_SUPPORT_EMAIL}>{PRODUCT_SUPPORT_EMAIL}</a>. </p>
          <p>
            Si tiene alguna pregunta sobre la privacidad de sus datos, consulte nuestra <a href='https://platform.beginbright.org/privacy_policy'>Política de Privacidad</a>.
          </p>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount_es;
